import axios from "axios";

const state = {
  status: "",
  isLoggedIn: false,
  user: {},
  userList: []
};

const mutations = {
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, user) {
    state.status = "success";
    state.isLoggedIn = true;
    state.user = user;
  },
  auth_error(state) {
    state.status = "error";
  },
  logout(state) {
    state.status = "";
    state.isLoggedIn = false;
    state.user = {};
  },
  updateUserList(state, userList) {
    state.userList = userList;
  }
};

const actions = {
  async login({ commit, state }, user) {
    commit("auth_request");
    try {
      let resp = await axios({
        url: "/api/login",
        data: user,
        method: "POST"
      });
      commit("auth_success", resp.data);
      if (!state.userList) {
        let userList = await initializeUsersList();
        commit("updateUserList", userList);
      }
    } catch (err) {
      commit("auth_error");
      throw new Error(err);
    }
  },
  async refresh_user({ commit, state }, user) {
    commit("auth_success", user);
    if (state.userList.length === 0) {
      let userList = await initializeUsersList();
      commit("updateUserList", userList);
    }
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/api/logout",
        method: "GET"
      })
        .then(resp => {
          commit("logout");
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default {
  state,
  mutations,
  actions
};

async function initializeUsersList() {
  try {
    let puserList = await axios({
      url: "/api/users-list-light",
      method: "GET"
    });

    return puserList.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
